import React, { useMemo, useRef } from 'react'
import { useDimensions } from '../../../hooks';
import { useTranslation } from 'react-i18next';
import ReactEcharts from "echarts-for-react";
import multiTooltip from './multi-tooltip';

function DailyGraph(props) {
    const { data, days, longDays } = props;
    const ref = useRef(null)
    const { width } = useDimensions(ref)
    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' });

    const option = useMemo(() => {
        if (!data) return;

        if (!data || !data.length) return;
        const ownBusiness = data.find(data => data.own_business)
        const otherBusinesses = data.find(data => !data.own_business)

        const option = {
            grid: { top: 44, right: 4, bottom: 24 },
            legend: { icon: 'roundRect' },
            xAxis: {
                type: 'category',
                data: days
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: t("myBusiness"),
                    type: 'line',
                    data: ownBusiness.data || [],
                    itemStyle: { color: "#00a4e0" },
                    lineStyle: { color: "#00a4e0" }

                },
                {
                    name: t("otherBusinesses"),
                    type: 'line',
                    data: otherBusinesses.data || [],
                    itemStyle: { color: "#69B75C" },
                    lineStyle: { color: "#69B75C" }
                },
            ],
            tooltip: {
                trigger: 'axis',
                confine: true,
                formatter: (params) => multiTooltip({
                    params,
                    formatByIndex: true,
                    formatAxisValueFn: (value) => longDays[value],
                    formatFn: (value) => value.toFixed(2)
                })
            }
        };
        return option;
    }, [i18n.language, days, longDays])


    return (
        <div className="dashboardView-card rasd-day dashboard-graph-card" ref={ref}>
            <p className="dashboardView-card-title">{t("dowVisits")}</p>

            {
                option
                    ? <ReactEcharts
                        option={option}
                        style={{ height: '100%' }}
                    />
                    : <p>N/D</p>
            }
        </div>
    )
}

export default DailyGraph